import { __module as l } from "./chunk759.js";
import { __require as B } from "./chunk648.js";
var S = l.exports, p;
function W() {
  return p ? l.exports : (p = 1, function(m, g) {
    (function(_, i) {
      m.exports = i(B());
    })(S, function(_) {
      return function() {
        var i = _, u = i.lib, A = u.WordArray, f = u.Hasher, b = i.algo, h = [], x = b.SHA1 = f.extend({
          _doReset: function() {
            this._hash = new A.init([
              1732584193,
              4023233417,
              2562383102,
              271733878,
              3285377520
            ]);
          },
          _doProcessBlock: function(t, c) {
            for (var r = this._hash.words, a = r[0], s = r[1], o = r[2], n = r[3], d = r[4], e = 0; e < 80; e++) {
              if (e < 16)
                h[e] = t[c + e] | 0;
              else {
                var H = h[e - 3] ^ h[e - 8] ^ h[e - 14] ^ h[e - 16];
                h[e] = H << 1 | H >>> 31;
              }
              var v = (a << 5 | a >>> 27) + d + h[e];
              e < 20 ? v += (s & o | ~s & n) + 1518500249 : e < 40 ? v += (s ^ o ^ n) + 1859775393 : e < 60 ? v += (s & o | s & n | o & n) - 1894007588 : v += (s ^ o ^ n) - 899497514, d = n, n = o, o = s << 30 | s >>> 2, s = a, a = v;
            }
            r[0] = r[0] + a | 0, r[1] = r[1] + s | 0, r[2] = r[2] + o | 0, r[3] = r[3] + n | 0, r[4] = r[4] + d | 0;
          },
          _doFinalize: function() {
            var t = this._data, c = t.words, r = this._nDataBytes * 8, a = t.sigBytes * 8;
            return c[a >>> 5] |= 128 << 24 - a % 32, c[(a + 64 >>> 9 << 4) + 14] = Math.floor(r / 4294967296), c[(a + 64 >>> 9 << 4) + 15] = r, t.sigBytes = c.length * 4, this._process(), this._hash;
          },
          clone: function() {
            var t = f.clone.call(this);
            return t._hash = this._hash.clone(), t;
          }
        });
        i.SHA1 = f._createHelper(x), i.HmacSHA1 = f._createHmacHelper(x);
      }(), _.SHA1;
    });
  }(l), l.exports);
}
export {
  W as __require
};
